<template>
  <div class="container_head">
    <!-- <van-form @submit="onSubmit"> -->
    <div class="tip">
      已认证房屋
      <div class="addhouse" @click="addhouse()">添加房屋</div>
    </div>
    <van-cell-group style="margin-top: 5px">
      <div v-for="(item, i) in userInfo.houses" :key='i' class="fangwu">
        <van-field
          v-model="item.communityName"
          :label="'小区名称'"
          input-align="right"
          readonly
        />
        <van-field
          :value="item.buildingNo+'栋'+item.unitName+'单元'+item.floorNum+'楼'+item.roomNo+'室'"
          label="房屋地址"
          input-align="right"
          readonly
          autosize
        />
        <van-field
          v-model="item.userType"
          label="角色"
          input-align="right"
          readonly
          autosize
        />
        <!-- type="textarea"  -->
      </div>
    </van-cell-group>
    <!-- </van-form> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Image as VanImage, Cascader, Popup, Field } from "vant";
Vue.use(VanImage).use(Cascader).use(Popup).use(Field);
import { mapState, mapMutations } from "vuex";
import chooseHouse from "../../components/choosehouse/index.vue";
export default {
  data() {
    return {
      show: false,
      uploaderlist: [],
      houseId: "",
      xzlist: {},
      idmen: {},
      sfchecked: "",
      currtbidx: "",
      userInfo: [],
    };
  },
  computed: {},
  components: {
    chooseHouse,
  },
  mounted() {
    this.$axios
      .get("/api/v2/wechat/user/userInfo", {
        params: {},
      })
      .then((res) => {
        this.userInfo = res;
        this.userInfo.houses.forEach((element) => {
          if (element.userType == 1) {
            element.userType = "业主";
          } else if (element.userType == 2) {
            element.userType = "业主家属";
          } else if (element.userType == 3) {
            element.userType = "租客";
          }
        });
      });
  },
  methods: {
    addhouse() {
      var data = {
        trueName: this.userInfo.trueName,
        cardId: this.userInfo.cardId,
        phone: this.userInfo.phone,
        cardType: this.userInfo.cardType,
      };
      this.$router.push({
        path: "/addhouse",
        query: data,
      });
    },
    tjfcz() {
      // this.$axios.post('/api/v1/wechat/user/addHouse', {
      // 	houseId: this.houseId
      // }).then(data => {
      // 	if (data) {
      // 		this.$dialog({
      // 			message: '添加成功'
      // 		}).then(res => {
      // 			this.$axios.get('/api/v2/wechat/user/userInfo').then(res => {
      // 				this.changeUserinfo(res);
      // 				// this.$emit('refresh');
      // 				// 触发router-view的refresh
      // 				this.$router.go(-1)
      // 			})
      // 		})
      // 	}
      // })
      console.log(this.xzlist);
      console.log(this.idmen);
      console.log(this.currtbidx);
      console.log(this.sfchecked);
      var finialobj = {};
      // if(this.sfchecked == ''){
      // 	this.$toast.fail('身份未选择')
      // }else{
      // 	if(this.currtbidx != 4){
      // 		finialobj = {
      // 			trueName:this.userInfo.trueName,
      // 			cardId:this.userInfo.cardId,
      // 			phone:this.userInfo.phone,
      // 			userType:this.sfchecked,
      // 		}
      // 		var xuankeys = Object.keys(this.idmen)
      // 		xuankeys.forEach(item=>{
      // 			finialobj[item] = this.idmen[item]
      // 		})
      // 		var keys = Object.keys(this.xzlist)
      // 		keys.forEach(item=>{
      // 			finialobj[item] = this.xzlist[item]
      // 		})
      // 		console.log(finialobj)
      // 	}else{
      // 		finialobj = {
      // 			trueName:this.userInfo.trueName,
      // 			cardId:this.userInfo.cardId,
      // 			phone:this.userInfo.phone,
      // 			villageId:this.idmen.villageId,
      // 			userType:this.sfchecked,
      // 			buildingId:this.idmen.buildingId,
      // 			bunitId:this.idmen.bunitId,
      // 			floorId:this.idmen.floorId,
      // 			houseId:this.idmen.houseId
      // 		}
      // 	}
      // 	this.$axios({
      // 		url: '/api/v2/wechat/user/register',
      // 		method: 'post',
      // 		data: finialobj,
      // 	}).then(res => {
      // 		// 0未认证  2：房主认证  20：待审核
      // 		// this.changeIdentity(20);
      // 		// Dialog({ message: '请耐心等待后台审核！' });
      // 		if(res){
      // 			this.$toast.success('成功！')
      // 			setTimeout(() => {
      // 				this.$router.push('/home')
      // 			}, 1000);
      // 		}
      // 	});

      // }
    },
    changeview(path) {
      this.$router.push(path);
    },

    validator(val) {
      return /^1(3|4|5|7|8)\d{9}$/.test(val);
    },
    validator2(val) {
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  color: #ffad0e;
  font-size: 18px;
  text-align: center;
  margin: 5px 0 10px;
  font-weight: bold;
  margin-top: 30px;
}
.fangwu {
  width: 90%;
  margin-left: 5%;
  margin-top: 10px;
  box-shadow: 0 0 10px #333;
  border-radius: 10px;
}
.flexcenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrxg {
  padding: 40px;
}

.tip {
  padding: 10px 15px;
  font-size: 14px;
  color: #00b5ff;
  font-weight: bold;
}

.addhouse {
  float: right;
  padding: 2px 5px;
  border: 1px solid #00b5ff;
}
</style>
